module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "smart__smart"
  }, [_c('div', {
    staticClass: "smart__stats"
  }, _vm._l((_vm.smartItems), function(item, index) {
    return _c('SmartStatItem', {
      key: index,
      attrs: {
        "text": item.text,
        "value": item.value
      }
    })
  }), 1), _c('div', {
    staticClass: "smart__results"
  }, [(_vm.hasTestResults) ? [_c('div', {
    staticClass: "smart__results-text"
  }, [_vm._v("Результаты тестирования от")]), _c('Select', {
    staticClass: "smart__results-select",
    attrs: {
      "value": _vm.selectInitValue,
      "options": _vm.testsForSelect,
      "name": "result",
      "placeholder": "Выберите дату"
    },
    on: {
      "change": _vm.testResultSelected
    }
  })] : [_c('div', {
    staticClass: "smart__results-warning"
  }, [_vm._v("Пройдите тестирование, чтобы мы нашли больше подходящих заданий")])], _c('div', {
    staticClass: "smart__actions"
  }, [_c('Button', {
    staticClass: "smart__action",
    attrs: {
      "color": "green",
      "size": "normal",
      "bold": true,
      "wide": true
    },
    on: {
      "click": _vm.startTest
    }
  }, [_vm._v("Пройти тестирование")])], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66f62975","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/smart/SmartBlock.vue
// module id = 304fc6c3c4b6d4913e3c
// module chunks = 89